import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Office } from 'app/core/models/office.model';
import { OfficeService } from 'app/core/services/office.service';
import { UserTimingService } from 'app/core/services/user-timing.service';

import { OfficeNavComponent } from '../../components/office-nav/office-nav.component';
import { OfficeHeaderComponent } from '../../components/office-header/office-header.component';
import { OfficeHeaderEditComponent } from '../../components/office-header-edit/office-header-edit.component';
import { OfficeDetailComponent } from '../../components/office-detail/office-detail.component';
import { OfficeCommunicationsComponent } from '../../components/office-communications/office-communications.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-office',
    templateUrl: './capture-admin-office.component.html',
    styleUrls: ['./capture-admin-office.component.scss'],
    imports: [OfficeNavComponent,
              RouterLink,
              OfficeHeaderComponent,
              OfficeHeaderEditComponent,
              OfficeDetailComponent,
              OfficeCommunicationsComponent,
              MatProgressSpinner]
})
export class CaptureAdminOfficeComponent implements OnInit, OnDestroy {
  private officeService = inject(OfficeService);
  private route = inject(ActivatedRoute);
  private userTimingService = inject(UserTimingService);

  office: Office;
  loading: boolean;
  editing: boolean;
  currentSection = 'officeDetails';

  ngOnInit() {
    this.init();
  }

  ngOnDestroy() {
    this.userTimingService.stop();
  }

  onSectionClick(section: string) {
    this.currentSection = section;
  }

  onEditDetails() {
    this.editing = true;
  }

  onEditDetailsCancel() {
    this.editing = false;
  }

  onUpdatedDetails() {
    this.editing = false;
    this.init();
  }

  private init() {
    const id = this.route.snapshot.paramMap.get('id');
    this.startUserTimingService(id);
    this.loading = true;
    this.editing = false;
    this.officeService.get(id).subscribe(office => {
      this.office = office;
      this.loading = false;
    });
  }

  private startUserTimingService(id) {
    this.userTimingService.track({
      page: 'capture_admin_office',
      recordId: id,
    });
  }
}
